import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bbdb158"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-viewer" }
const _hoisted_2 = { class: "pdf-viewer__toolbar" }
const _hoisted_3 = { class: "pdf-viewer__meta" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pdf-viewer__badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-pdf-box" }),
  /*#__PURE__*/_createTextVNode(" PDF ")
], -1))
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "pdf-viewer__actions" }
const _hoisted_7 = { class: "pdf-viewer__stage" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "pdf-viewer__loading"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading document…", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PProgressSpinner = _resolveComponent("PProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", {
          class: "pdf-viewer__name",
          title: _ctx.fileName
        }, _toDisplayString(_ctx.fileName), 9, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_PButton, {
          icon: "pi pi-external-link",
          label: "Open",
          size: "small",
          severity: "secondary",
          outlined: "",
          onClick: _ctx.openInNewTab
        }, null, 8, ["onClick"]),
        _createVNode(_component_PButton, {
          icon: "pi pi-download",
          label: "Download",
          size: "small",
          onClick: _ctx.download
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(), _createElementBlock("iframe", {
        key: _ctx.pdfUrl,
        src: _ctx.pdfUrl,
        class: "pdf-viewer__iframe",
        title: "PDF document",
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLoaded && _ctx.onLoaded(...args)))
      }, null, 40, _hoisted_8)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_PProgressSpinner, {
              style: {"width":"2.25rem","height":"2.25rem"},
              strokeWidth: "4"
            }),
            _hoisted_10
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}